import { render, staticRenderFns } from "./PriceUnit.vue?vue&type=template&id=71f59518&scoped=true"
import script from "./PriceUnit.vue?vue&type=script&lang=ts"
export * from "./PriceUnit.vue?vue&type=script&lang=ts"
import style0 from "./PriceUnit.vue?vue&type=style&index=0&id=71f59518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f59518",
  null
  
)

export default component.exports